export default "__VITE_ASSET__029cbc06__"